module.exports = __webpack_public_path__ + "img/dots-grid.1f65877f.svg";